import Vue from 'vue';
import VueMq from 'vue-mq';

import Filters from '@js/filters';
import AboutPage from './components/AboutPage';
import { breakpoints } from '@js/constants/constants';

Vue.component('about-page', AboutPage);

Vue.use(Filters);
Vue.use(VueMq, {
  breakpoints,
  defaultBreakpoint: 'xs'
});

new Vue({
  el: '.about-page',
});
